import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { VKWrapper } from './components/vk';
import { Preloader } from './components/preloader';
import { Filter } from './components/filter';
import { Navigation } from './components/navigation';
import { Schedule } from './components/schedule';
import { ServicesModule } from './modules/services';
import { SpecialistsModule } from './modules/specialists';
import { SuccessScreen, TariffEndScreen } from './components/screens';
import { NearTickets } from './components/nearTickets';
import { TooltipNotify } from './components/tooltip';
import { API_SERVER } from './constans/api';
import { switchInitAction } from './components/filter/actions';
import { getScheduleAction, resetDataScheduleAction } from './components/schedule/actions';
import { setScheduleInterval } from './helpers';
import { initialState as initFilter } from './components/filter/reducer';

class App extends React.Component {
    componentDidMount() {
        const { filter, dispatch } = this.props;
        dispatch(getScheduleAction(filter));
        setScheduleInterval(filter, dispatch);
    }

    toMain = () => {
        const {
            dispatch,
            filter
        } = this.props;

        if (filter.typeView.value !== 'month') {
            dispatch(resetDataScheduleAction());
            dispatch(switchInitAction());
            dispatch(getScheduleAction({ ...filter, ...initFilter }));
            setScheduleInterval({ ...filter, ...initFilter }, dispatch);
        }
    }

    render() {
        const {
            schedule,
            module,
            dispatch,
            filter,
            vk
        } = this.props;
        const { typeView } = filter;
        const { screens } = schedule;
        const { settings } = schedule;
        const logo = settings && settings.logo ? `${API_SERVER}${settings.logo}` : '//module.vpriem.ru/app/dist/assets/logo.png';

        if (screens.tariffEnd.active) {
            return <TariffEndScreen />;
        }

        if (screens.success.active) {
            return <SuccessScreen />;
        }

        if (schedule.data === null) return <Preloader fixed />;

        if (module.name) {
            switch (module.name) {
                case 'services':
                    return (
                        <div className="app">
                            <ServicesModule />
                        </div>
                    );
                case 'specialists':
                    return (
                        <div className="app">
                            <SpecialistsModule />
                        </div>
                    );
                default:
                    return null;
            }
        }

        const { search } = window.location;
        let platform = null;
        if (search !== '') {
            const params = new URLSearchParams(search);
            platform = params.get('vk_platform');
        }

        return (
            <div className="app" style={{ position: vk.userID ? 'unset' : 'relative' }}>
                <div className="schedule__header">
                    {platform === null && (
                    <div className="schedule__header__logo-wrap">
                        <button
                            type="button"
                            className="schedule__header__logo"
                            style={{ backgroundImage: `url('${logo}')` }}
                            onClick={this.toMain}
                        />
                    </div>
                    )}
                    <Filter />
                    <Navigation />
                    <NearTickets />
                </div>
                <Schedule />
                <TooltipNotify />
            </div>
        );
    }
}

App.propTypes = {
    schedule: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    module: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    vk: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    schedule: state.schedule,
    module: state.module,
    filter: state.filter,
    vk: state.vk
});

const wrapper = compose(
    connect(mapStateToProps),
    VKWrapper
);

export default wrapper(App);
